import _ from 'lodash';
import { getRequest, postRequest } from '../../Common/network-call';
import { INSTANCE_URL } from '../../Common/constant';

export const ALL_SPEAKERS_LIST = 'ALL_SPEAKERS_LIST';
export const ALL_SPONSORS_LIST = 'ALL_SPONSORS_LIST';
export const ALL_EXHIBITORS_LIST = 'ALL_EXHIBITORS_LIST';
export const SEEN_EVENT_ADS = 'SEEN_EVENT_ADS';

export const fetchAllSpeakers_Overview = (
  session,
  sortby = 'randomly',
  callback
) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let orderby = sortby === 'az' ? 'firstname%20ASC' : 'createdon%20DESC';
  let fields =
    'speakerid,company,description,eventid,featured,firstname,isactive,isfeatured,lastname,position,profileimage';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/speaker?include_count=true&fields=${fields}&filter=(${filter})&order=${orderby}&limit=30`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: ALL_SPEAKERS_LIST,
          payload: { resource: data.resource }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchAllSponsors_Overview = (session, sortby = 'az', callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let orderby = sortby === 'randomly' ? 'createdon%20DESC' : 'name%20ASC';
  let fields =
    'sponsorid,name,sponsor_spoc,logoimgpath,eventid,description,comesfrom,categoryid';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/sponsor?include_count=true&fields=${fields}&related=membershiptype_by_categoryid&filter=(${filter})&order=${orderby}&limit=30&offset=0`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // listing sponsors membership priority wise
        let arr = _.sortBy(data.resource, spon => {
          return spon.membershiptype_by_categoryid?.priorityindex;
        });
        data.resource = arr;

        dispatch({
          type: ALL_SPONSORS_LIST,
          payload: { resource: data.resource }
        });
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchAllExhibitors_Overview = (
  session,
  sortby = 'az',
  callback
) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let orderby = sortby === 'randomly' ? 'createdon%20DESC' : 'name%20ASC';
  let fields =
    'exhibitorid,eventid,comesfrom,about,booth,featured,name,profileimage';
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?include_count=true&fields=${fields}&filter=(${filter})&order=${orderby}&limit=30`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: ALL_EXHIBITORS_LIST,
          payload: { resource: data.resource }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const setSeenAds = adlist => {
  return dispatch => {
    dispatch({ type: SEEN_EVENT_ADS, payload: adlist });
  };
};
